module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"summary":"Consolidado","receivables":"Recebíveis","adjustments":"Ajustes","sales":"Vendas","fees":"Taxas"},"en-US":{"summary":"Summary","receivables":"Receivables","adjustments":"Adjustments","sales":"Sales","fees":"Fees"}}')
  delete Component.options._Ctor
}
